import { useEffect, useState } from 'react'

export default function useContainerResize<T extends HTMLElement>(callback: () => void) {
  const [container, setContainer] = useState<T | null>(null)

  useEffect(() => {
    if (!container) return

    const observer = new ResizeObserver(callback)

    observer.observe(container)

    return () => {
      observer.disconnect()
    }
  }, [callback, container])

  return { target: (target: T) => setContainer(target) }
}
